<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Orders">Orders</span>
      </div>

      <!-- Center -->
      <div class="app-toolbar-center">
    <div>
        <button (click)="showPickSheetPrinted = !showPickSheetPrinted; getData();" mat-icon-button color="primary"><mat-icon *ngIf="!showPickSheetPrinted" i18n-title="@@Show Printed and Not Printed Picksheets" title="Show Printed and Not Printed Pick Sheets" color="accent">timeline</mat-icon><mat-icon *ngIf="showPickSheetPrinted" i18n-title="@@Show Only Not Printed Picksheets" title="Show Only Not Printed Pick Sheets" style="color: blue">timeline</mat-icon></button>
      <button (click)="showShipped = !showShipped; getData();" mat-icon-button color="primary"><mat-icon *ngIf="!showShipped" i18n-title="@@Show Shipped and Not Shipped" title="Show Shipped and Not Shipped" color="accent">curtains_closed</mat-icon><mat-icon *ngIf="showShipped" i18n-title="@@Show Only Not Shipped" title="Show Only Not Shipped" style="color: blue">curtains_closed</mat-icon></button>
    </div>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="fulfillmentorders"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="app-content app-table-content">
        <app-table *ngIf="columns && eventHandler && renderedData" [columns]="columns" [eventHandler]="eventHandler" [data]="renderedData" [expandedTableRowTemplate]="expandedTableRowTemplate" [dataServiceStatus]="'LOADED'" [showFilters]="true">
          <ng-template #expandedTableRowTemplate let-element>
            <app-fulfilment-order [printNodeOrder]="element"></app-fulfilment-order>
          </ng-template>
        </app-table>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>






